import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as _throw } from 'rxjs';
import { catchError, finalize, share } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { LOGIN_ROUTE } from '../constants/constants';
import { LoadingService } from '@shared/services/loading.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly loadingService: LoadingService,
    private readonly storageService: StorageService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isStaticAsset = request.url.includes('/assets/')
  || request.url.endsWith('.css')
  || request.url.endsWith('.js')
  || request.url.endsWith('.ico')
  || request.url.endsWith('.json'); // include i18n

    if (isStaticAsset) {
      return next.handle(request); // passa tutto senza loader / token / headers
    }

    const skipLoader = request.headers.has('X-Skip-Loader');

    if (skipLoader) {
      request = request.clone({
        headers: request.headers.delete('X-Skip-Loader')
      });
    } else {
      this.loadingService.show();
    }


    const user = this.storageService.getFromLocalOrSessionStorage('user');


    let token: string | null = null;
    if (user) {
      token = user.token;
    }

    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      });
    }

    request = request.clone({
      headers: request.headers.set('Accept', 'application/json')
    });

    return this.makeRequest(request, next, skipLoader);
  }

  makeRequest(request: HttpRequest<any>, next: HttpHandler, skipLoader: boolean): Observable<HttpEvent<any>> {

    const req: Observable<HttpEvent<any>> = next.handle(request).pipe(
      share(),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.sessionExpired(err);
        }
        return _throw(() => err);
      }),
      finalize(() => {
        if (!skipLoader) {
          this.loadingService.hide();
        }
      })
    );

    return req;
  }

  sessionExpired(err: any) {
    localStorage.clear();

    if (err instanceof HttpErrorResponse) {
      setTimeout(() => this.router.navigate([LOGIN_ROUTE]), 3000);
    }
  }
}
